export enum MissionTypeAvailabilityEnum {
  D_DAY = 'D_DAY',
  D_MINUS_1 = 'D_MINUS_1',
  D_PLUS_1 = 'D_PLUS_1'
}

export const missionTypeAvailabilityEnumMapping: Record<MissionTypeAvailabilityEnum, string> = {
  [MissionTypeAvailabilityEnum.D_DAY]: 'Jour J',
  [MissionTypeAvailabilityEnum.D_MINUS_1]: 'J-1',
  [MissionTypeAvailabilityEnum.D_PLUS_1]: 'J+1'
}
